import React, {Component} from 'react';
import {connect} from 'react-redux';
import SolicitorGroup from "../../components/solicitorGroup/solicitorGroup";
import {
    changeAdExpenseTypes,
    changeAdvancedDisbursementsFormData,
    changeSelectedToba,
    changeReferToByCaseType,
    changeReferToBySubCaseType,
    changeSolicitorGroupField,
    requestGetSolicitorGroups,
    requestGetSpecificSolicitorGroupEdit,
    requestGetUnderwriters,
    requestGetWorkSources,
    requestPatchSelectedSolicitorGroup,
    requestPatchSolicitorGroup,
    requestPostSolicitorGroup,
    addSolicitorGroupUnderwriter, editSolicitorGroupUnderwriter, removeSolicitorGroupUnderwriter
} from "../../actions/solicitorGroup";
import {changeField} from "../../actions/applicationFormreferralSettings";
import {requestLawsysFirmsFiltered, changeLawsysFirmState} from "../../actions/lawsysFirms";
import {requestDeleteSolicitorGroup} from "../../actions/solicitorGroupList";
import {requestGetSpecificSolicitorGroup} from "../../actions/groups";
import _ from 'lodash';
import { push,goBack } from 'connected-react-router';

import {getCaseTypes} from "../../actions/caseTypes";
import {getExpenseTypes} from "../../actions/expenseTypes";
import {getTobas} from "../../actions/tobas";
import {getValidTobas} from "../../actions/tobas";
import {fetchWordingCategories} from "../../actions/wordingCategories";
import moment from "moment";
import {handleADcaseTypes, handleADSubCaseTypes} from '../../helpers/advanceDisbursments/advanceDisbursements';
import { LEGAL_ADVICE_TEXT } from "../../helpers/variables";

class SolicitorGroupHOC extends Component {
    componentWillMount() {
        let route = this.props.router.location.pathname;
        let splitedRoute = _.split(route,'/',5);
        this.props.getValidTobas({limit: 0, offset: 0});
        if (route.includes('/solicitors/solicitor-groups/edit-solicitor-group')) {
                this.props.requestGetSpecificSolicitorGroupEdit(splitedRoute[4])
        }
        else {
            this.props.getExpenseTypes();
            //this.props.getSolicitors();
            if(!(this.props.storeIsValid === true)){
            this.props.getCaseTypes();
            this.props.getWorkSources();
            }

            this.props.getUnderwriters();
        }
        this.props.getSolicitorGroups();
        this.props.fetchWordingCategories();
    };

    _createSendBodyForSolicitorGroupPostRequest = () => {
        return {
            name: this.props.solicitorGroup.name,
            requiredWorkSource: this.props.solicitorGroup.requiredWorkSource,
            solicitors: this.props.solicitorGroup.selectedSolicitors.map(value => Object({
                'lawsysFirmId': value.id,
                'lawsysFirm': value.name
            })),
            underwriters: this.props.solicitorGroup.groupUnderwriters.map(i => ({
                underwriterId: i.underwriterId,
                validFrom: moment(i.validFrom).format('YYYY-MM-DD'),
                validTo: i.validTo?moment(i.validTo).format('YYYY-MM-DD'):null,
                UpdateRelatedPolicies: i.updateRelatedPolicies,
            })),
            wordingCategoryId: parseInt(this.props.solicitorGroup.selectedWordingCategory),
            workSource: this.props.solicitorGroup.selectedWorkSources.map(value => value.id),
            caseTypes: this.getCaseTypesForRequest(),
            disbursementsCaseTypeAndExpenseDtos: this._getAdCaseTypeAndExpenseDtos(),
            disbursementsAllowed: this.props.solicitorGroup.advancedDisbursementsFormData.shouldBeAbleToApply,
            updateCaseBeforeDisbursements: this.props.solicitorGroup.advancedDisbursementsFormData.shouldProvideCaseUpdate,
            maxWeeksSinceLastUpdateToAllowDisbursementsApplication: this.props.solicitorGroup.advancedDisbursementsFormData.numberOfWeeks? parseInt(this.props.solicitorGroup.advancedDisbursementsFormData.numberOfWeeks) : 0,
            tobaDto: {id: this.props.solicitorGroup.selectedToba?this.props.solicitorGroup.selectedToba: null},
            minDisbursementAmount: this.props.solicitorGroup.advancedDisbursementsFormData.minDisbursementAmount?this.props.solicitorGroup.advancedDisbursementsFormData.minDisbursementAmount:null,
            maxDisbursementAmount: this.props.solicitorGroup.advancedDisbursementsFormData.maxDisbursementAmount?this.props.solicitorGroup.advancedDisbursementsFormData.maxDisbursementAmount:null,
            maxAggregatedDisbursementAmount: this.props.solicitorGroup.advancedDisbursementsFormData.maxAggregatedDisbursementAmount?this.props.solicitorGroup.advancedDisbursementsFormData.maxAggregatedDisbursementAmount:null,
            attachXmlInEmails: this.props.solicitorGroup.attachXmlInEmails,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        clearTimeout(this.askServer);
        if (this.props.solicitorGroup.patchCounter === this.props.solicitorGroup.totalPatches) {
            let route = this.props.router.location.pathname;
            let splitedRoute = _.split(route,'/',5);

            let sendBody = this._createSendBodyForSolicitorGroupPostRequest();
            if (!route.includes('/solicitors/solicitor-groups/edit-solicitor-group')) {
                this.props.postNewSolicitorGroup(sendBody);
            }
            else {
                sendBody = {...sendBody, id: this.props.solicitorGroup.receivedGroupId};
                this.props.requestPatchSelectedSolicitorGroup(this.props.solicitorGroup.receivedGroupId,sendBody);
            }
        }
        if(prevProps.postingNewToba && !this.props.postingNewToba){
            this.props.getTobas({limit: 0, offset: 0});
        }
        if(this.props.lawsysFirms.suggestionFieldValue !== prevProps.lawsysFirms.suggestionFieldValue
            && this.props.lawsysFirms.suggestionFieldValue.length >= 3)
        {
            this.askServer = setTimeout(() => {
                this.props.requestLawsysFirmsFiltered( {
                    search:  this.props.lawsysFirms.suggestionFieldValue,
                })
            }, 500);
        }
    }

    //action that handles the multi select list of case types
    handleSelectMultipleCaseTypes = (key, value) => {
        let selectedCaseTypeIndex;
        let selectedCaseTypes = [...this.props.solicitorGroup.selectedCaseTypes];
        let checkedCaseTypesIds = [...this.props.solicitorGroup.checkedCaseTypesIds];
        let caseTypes = this.props.caseTypes.cases;

        if(this.shouldUpdateSelectedCases(parseInt(value))){
            if (this.props.solicitorGroup.checkedCaseTypesIds.includes(value)) {
                let referToByCaseType = {...this.props.solicitorGroup.referToByCaseType}; //update refer to by case type checkboxes
                delete referToByCaseType[value];
                let index = checkedCaseTypesIds.indexOf(value);
                if (index > -1) {
                    checkedCaseTypesIds.splice(index, 1);
                }
                for (let i = 0; i < selectedCaseTypes.length; i++) {
                    if (selectedCaseTypes[i].id === value) {
                        selectedCaseTypeIndex = i;
                        break;
                    }
                }
                if (selectedCaseTypeIndex > -1) {
                    selectedCaseTypes.splice(index, 1);
                }
                this.props.changeInputGroup('selectedCaseTypes', selectedCaseTypes);
                this.props.changeInputGroup('checkedCaseTypesIds', checkedCaseTypesIds);

                this.props.changeInputGroup('referToByCaseType', referToByCaseType);
            }
            else {
                selectedCaseTypes.push(...caseTypes.filter(item => (parseInt(value) === item.id)));
                checkedCaseTypesIds.push(value);
                this.props.changeInputGroup('selectedCaseTypes', selectedCaseTypes);
                this.props.changeInputGroup('checkedCaseTypesIds', checkedCaseTypesIds);
                this.props.changeInputGroup('referToByCaseType', {
                    ...this.props.solicitorGroup.referToByCaseType,
                    [value]: {
                        cmu: false,
                        tuw: false,
                        medical: false
                    }
                }); ///update refer to by case type checkboxes
            }
        }
    };

    //function than handles the checked state of cases
    handleCaseTypesCheckedState = (caseTypeId, group) => {
        let checkedCaseTypesIds = this.props.solicitorGroup.checkedCaseTypesIds;
        if (checkedCaseTypesIds.includes(caseTypeId))
            return true;
        else return false
    };

    //function that calculated if the case type could be un checked.
    shouldUpdateSelectedCases = (newCaseTypeId) => {
        let checkedCaseTypesIds = [...this.props.solicitorGroup.checkedCaseTypesIds];
        let selectedSubCaseTypes = [...this.props.solicitorGroup.selectedSubCaseTypes];
        if(checkedCaseTypesIds.includes(newCaseTypeId)){
            let subCasesOfNewCaseType = _.find(selectedSubCaseTypes, item => {return item.caseTypeId === newCaseTypeId} )
            if(subCasesOfNewCaseType){
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };

    //action that handles the multi select list of sub cases
    handleSelectMultipleSubCaseTypes = (key, value) => {
        let selectedSubCaseTypeIndex;
        let selectedSubCaseTypes = [...this.props.solicitorGroup.selectedSubCaseTypes];
        let checkedSubCaseTypesIds = [...this.props.solicitorGroup.checkedSubCaseTypesIds];
        let subCaseTypes = this.props.caseTypes.subCases;

        if (this.props.solicitorGroup.checkedSubCaseTypesIds.includes(value)) {
            let referToBySubCaseType = {...this.props.solicitorGroup.referToBySubCaseType}; //update the refer to by sub case type checkboxes
            delete referToBySubCaseType[value];
            let index = checkedSubCaseTypesIds.indexOf(value);
            if (index > -1) {
                checkedSubCaseTypesIds.splice(index, 1);
            }
            for (let i = 0; i < selectedSubCaseTypes.length; i++) {
                if (selectedSubCaseTypes[i].id === value) {
                    selectedSubCaseTypeIndex = i;
                    break;
                }
            }
            if (selectedSubCaseTypeIndex > -1) {
                selectedSubCaseTypes.splice(index, 1);
            }
            this.props.changeInputGroup('selectedSubCaseTypes', selectedSubCaseTypes);
            this.props.changeInputGroup('checkedSubCaseTypesIds', checkedSubCaseTypesIds);

            this.props.changeInputGroup('referToBySubCaseType', referToBySubCaseType);//update the refer to by sub case type checkboxes
        }
        else {
            selectedSubCaseTypes.push(...subCaseTypes.filter(item => (parseInt(value) === item.id)));
            checkedSubCaseTypesIds.push(value);
            this.props.changeInputGroup('selectedSubCaseTypes', selectedSubCaseTypes);
            this.props.changeInputGroup('checkedSubCaseTypesIds', checkedSubCaseTypesIds);

            this.props.changeInputGroup('referToBySubCaseType', {
                ...this.props.solicitorGroup.referToBySubCaseType,
                [value]: {
                    cmu: false,
                    tuw: false,
                    medical: false
                }
            });//update the refer to by sub case type checkboxes
        }
    };

    //function than handles the checked state of sub cases
    handleSubCaseTypesCheckedState = (subCaseTypeId, group) => {
        let checkedSubCaseTypesIds = this.props.solicitorGroup.checkedSubCaseTypesIds;
        if (checkedSubCaseTypesIds.includes(subCaseTypeId))
            return true;
        else return false
    };

    //function that calculated the sub cases to be features on the multi select based on the selected case types
    getSubCasesBasedOnSelectedCases = () => {
        let checkedCaseTypesIds = [...this.props.solicitorGroup.checkedCaseTypesIds];
        let subCaseTypes = this.props.caseTypes.subCases;
        let featuredSubCases = [];
        _.forEach(checkedCaseTypesIds, (caseTypeId) => {
            featuredSubCases = [...featuredSubCases, ..._.filter(subCaseTypes, item => {return item.caseTypeId === caseTypeId} )]
        });
        return featuredSubCases;
    };

    handleSelectMultipleChange = (key, value) => {
        if (key === 'selectedWorkSources') {
            let selectedWorkSourcesIndex;
            let selectedWorkSources = [...this.props.solicitorGroup.selectedWorkSources];
            let checkedWorkSourcesIds = [...this.props.solicitorGroup.checkedWorkSourcesIds];
            let workSources = this.props.solicitorGroup.workSources;
            if (this.props.solicitorGroup.checkedWorkSourcesIds.includes(value)) {
                let index = checkedWorkSourcesIds.indexOf(value);
                if (index > -1) {
                    checkedWorkSourcesIds.splice(index, 1);
                }
                for (let i = 0; i < selectedWorkSources.length; i++) {
                    if (selectedWorkSources[i].id === value) {
                        selectedWorkSourcesIndex = i;
                        break;
                    }
                }
                if (selectedWorkSourcesIndex > -1) {
                    selectedWorkSources.splice(index, 1);
                }
                if(selectedWorkSources.length === 0){
                    this.props.changeInputGroup('requiredWorkSource', false);
                }
                this.props.changeInputGroup('selectedWorkSources', selectedWorkSources);
                this.props.changeInputGroup('checkedWorkSourcesIds', checkedWorkSourcesIds);
            }
            else {
                selectedWorkSources.push(...workSources.filter(item => (parseInt(value) === item.id)));
                checkedWorkSourcesIds.push(value);
                this.props.changeInputGroup('selectedWorkSources', selectedWorkSources);
                this.props.changeInputGroup('checkedWorkSourcesIds', checkedWorkSourcesIds);
            }
        }
    };

    handleCheckedState = (questionId, group) => {
        if (group === 'selectedWorkSources') {
            let checkedWorkSourcesIds = this.props.solicitorGroup.checkedWorkSourcesIds;
            if (checkedWorkSourcesIds.includes(questionId))
                return true;
            else return false
        }
        else return false
    };


    handleInputChange = (evt) => {
        let group = [];
        let underwriters = this.props.solicitorGroup.underwriters;
        group = underwriters.filter(value => (parseInt(evt.target.value) === value.id))[0]
        if (group == null)
            group = {
                id: '',
                value: ''
            }
        this.props.changeInputGroup(evt.target.name, group)
    };

    handleWordingCategoryChange = (evt) => {
        this.props.changeInputGroup(evt.target.name, evt.target.value)
    };

    //function that returns true if sub case type belongs to the specified case type (based on sub case machineName)
    _belongsToCaseTypeByMachineName = (subCaseTypeMachineName, caseTypeId) => {
        let x = _.find(this.props.caseTypes.cases, caseType => {
            return caseType.id === caseTypeId
        });
        if(x){
            let y = _.find(x.subCaseTypes, s => {
                return s.machineName === subCaseTypeMachineName;
            });
            if(y) {
               return true;
            }
        }
        return false;
    };

    //function that calculates the case types and sub case types to be posted/patched to the api
    getCaseTypesForRequest = () => {
        let selectedSubCaseTypes = [...this.props.solicitorGroup.selectedSubCaseTypes];
        let selectedCaseTypes = [...this.props.solicitorGroup.selectedCaseTypes];
        let sendBodyItem = [];
        _.forEach(selectedCaseTypes, caseType => {
            sendBodyItem = [...sendBodyItem, {
                id: caseType.id,
                ...this.props.solicitorGroup.referToByCaseType[caseType.id],
                subCaseTypes: _.filter(selectedSubCaseTypes, subCaseType => {
                    return this._belongsToCaseTypeByMachineName(subCaseType.machineName, caseType.id)
                }).map(item => { return {id:item.id, ...this.props.solicitorGroup.referToBySubCaseType[item.id],} })
            }]
        });
        return sendBodyItem;
    };

    _calculateWarningsBeforeSubmit = () => {
        let warnings = {};
        if (this.props.solicitorGroup.tobaChanged) {
            warnings = {
                ...warnings,
                selectedTobaMsg: 'allocated a new TOBA'
            };
        }
        if(this.props.solicitorGroup.advancedDisbursementsFormData.shouldBeAbleToApply){
            warnings = {
                ...warnings,
                adWarningMessage: 'chosen to allow this solicitor group to apply for Advance Disbursements'
            };
        }
        return warnings;
    };

    HandleSubmit = (evt) => {
        evt.preventDefault();
        let sendBody = {};
        let route = this.props.router.location.pathname;
        let splitedRoute = _.split(route,'/',5);
        let warnings = this._calculateWarningsBeforeSubmit();
        if(_.size(warnings) > 0 && _.size(this.props.solicitorGroup.warnings) === 0){
            this.props.changeInputGroup('warnings', warnings);
            return 0;
        }
        else if (_.size(this.props.solicitorGroup.warnings) > 0){
            this.props.changeInputGroup('warnings', {});
        }
        if (parseFloat(this.props.solicitorGroup.advancedDisbursementsFormData.maxDisbursementAmount) < parseFloat(this.props.solicitorGroup.advancedDisbursementsFormData.minDisbursementAmount) ) {
            this.props.changeInputGroup('badResponseMessage', 'Maximum amount must be greater than or equal to minimum amount.');
            return 0;
        }
        if(parseFloat(this.props.solicitorGroup.advancedDisbursementsFormData.maxDisbursementAmount) > parseFloat(this.props.solicitorGroup.advancedDisbursementsFormData.maxAggregatedDisbursementAmount)){
            this.props.changeInputGroup('badResponseMessage', 'Aggregate amount must be greater than or equal to maximum amount.');
            return 0;
        }
        if(!this.props.solicitorGroup.selectedWordingCategory) {
            this.props.changeInputGroup('badResponseMessage', 'Please select a wording category before submit.')
        }
        if (this.props.solicitorGroup.selectedSolicitors.length === 0) {
            this.props.changeInputGroup('badResponseMessage', 'Please select at least one solicitor before submit.')
        }
        else if (this.props.solicitorGroup.checkedCaseTypesIds.length === 0){
            this.props.changeInputGroup('badResponseMessage', 'Please select at least one case type before submit.')
        }
        else if ((this.props.solicitorGroup.badResponse.length === 0 || !Array.isArray(this.props.solicitorGroup.badResponse)) && !(route.includes('/solicitors/solicitor-groups/edit-solicitor-group'))) {
            sendBody = this._createSendBodyForSolicitorGroupPostRequest();
            this.props.postNewSolicitorGroup(sendBody)
        }
        else if ((route.includes('/solicitors/solicitor-groups/edit-solicitor-group')) && (this.props.solicitorGroup.badResponse.length === 0)) {
            let patchBody = {...this._createSendBodyForSolicitorGroupPostRequest(), id: parseInt(this.props.solicitorGroup.receivedGroupId)};
            this.props.requestPatchSelectedSolicitorGroup(this.props.solicitorGroup.receivedGroupId, patchBody)
        }
        else if (this.props.solicitorGroup.badResponse.length > 0 && Array.isArray(this.props.solicitorGroup.badResponse)) {
            let solicitorInGroups = this.props.solicitorGroup.badResponse;
            let patchBody = {};
            let groupIdChecked = [];
            for (let i = 0; i < solicitorInGroups.length; i++) {
                patchBody = _.find(this.props.solicitorGroup.groups,
                        value => {
                    return value.id === solicitorInGroups[i].SolicitorGroupId
                });
                if (groupIdChecked.includes(patchBody.id))
                    continue;
                for (let j = 0; j < solicitorInGroups.length; j++) {
                    for (let k = 0; k < patchBody.solicitors.length; k++) {
                        if (patchBody.solicitors[k].lawsysFirmId == solicitorInGroups[j].LawsysFirmId) {
                            patchBody.solicitors.splice(k, 1);
                        }
                    }

                }
                patchBody = {...patchBody}; //workSource property is accepted (int array) from the api and not workSources
                delete patchBody.workSources;

                this.props.patchSolicitorGroup(patchBody.id, patchBody);
                groupIdChecked.push(patchBody.id);
                this.props.changeInputGroup('totalPatches', groupIdChecked.length)
            }
        }
    };

    //change the active panel
    _changePanel = (panel) => {
        this.props.changeInputGroup('activePanel', panel)
    };

    //changes the advanced disbursements form checkboxes
    _handleAdvancedDisbursementsCheckBoxes= (evt) => {
        this.props.changeAdvancedDisbursementsFormData({key:evt.target.name,value:evt.target.checked});
    };

    _handleAdvancedDisbursementsNumberOfWeeksCheckBox= (evt) => {
        if(!this.props.solicitorGroup.advancedDisbursementsFormData.numberOfWeeks){
            this.props.changeAdvancedDisbursementsFormData({key:'numberOfWeeks',value: '27'});
        }
        this.props.changeAdvancedDisbursementsFormData({key:evt.target.name,value: evt.target.checked});
    };

    _handleAdvancedDisbursementsMultipleExpenseTypes = (key, value) => {
        let selectedExpenseTypeIndex;
        let selectedExpenseTypes= [...this.props.solicitorGroup.advancedDisbursementsFormData.selectedExpenseTypes];
        let checkedExpenseTypesIds = [...this.props.solicitorGroup.advancedDisbursementsFormData.checkedExpenseTypesIds];
        let expenseTypes = [...this.props.getExpenseTypes];

        if (checkedExpenseTypesIds.includes(value)) {
            let index = checkedExpenseTypesIds.indexOf(value);
            if (index > -1) {
                checkedExpenseTypesIds.splice(index, 1);
            }
            for (let i = 0; i < selectedExpenseTypes.length; i++) {
                if (selectedExpenseTypes[i].id === value) {
                    selectedExpenseTypeIndex = i;
                    break;
                }
            }
            if (selectedExpenseTypeIndex > -1) {
                selectedExpenseTypes.splice(index, 1);
            }
            this.props.changeAdvancedDisbursementsFormData({key:'selectedExpenseTypes', value:selectedExpenseTypes});
            this.props.changeAdvancedDisbursementsFormData({key:'checkedExpenseTypesIds',value: checkedExpenseTypesIds});
        }
        else {
            selectedExpenseTypes.push(...expenseTypes.filter(item => (parseInt(value) === item.id)));
            checkedExpenseTypesIds.push(value);
            this.props.changeAdvancedDisbursementsFormData({key:'selectedExpenseTypes',value: selectedExpenseTypes});
            this.props.changeAdvancedDisbursementsFormData({key:'checkedExpenseTypesIds',value: checkedExpenseTypesIds});
        }

    };

    _handleAdvancedDisbursementsCheckedExpenseTypes = (questionId, group) => {
        let checkedExpenseTypesIds = [...this.props.solicitorGroup.advancedDisbursementsFormData.checkedExpenseTypesIds];
        if (checkedExpenseTypesIds.includes(questionId))
            return true;
        else return false
    };

    _handleAdvancedDisbursementsMultipleCaseTypes = (key, value) => {
        let selectedCaseTypes = [...this.props.solicitorGroup.advancedDisbursementsFormData.selectedCaseTypes];
        let checkedCaseTypesIds = [...this.props.solicitorGroup.advancedDisbursementsFormData.checkedCaseTypesIds];
        let caseTypes = [...this.props.caseTypes.cases];

        let advancedDisbursementsCaseTypes={
            value:value,
            selectedCaseTypes:selectedCaseTypes,
            checkedCaseTypesIds:checkedCaseTypesIds,
            caseTypes:caseTypes,
            selectedCaseTypeIndex:null,
            changeAdvancedDisbursementsFormData:this.props.changeAdvancedDisbursementsFormData,
            expenseTypes:{...this.props.solicitorGroup.advancedDisbursementsFormData.checkedExpenseTypesPerCaseType},
            solicitorGroup:this.props.solicitorGroup

        }
        if(this._shouldUpdateAdSelectedCases(parseInt(value))) {
            handleADcaseTypes(advancedDisbursementsCaseTypes);

         }
    };



    _handleAdvancedDisbursementsCheckedCaseTypes = (questionId, group) => {
        let selectedCaseTypesIds = [...this.props.solicitorGroup.advancedDisbursementsFormData.checkedCaseTypesIds];
        if (selectedCaseTypesIds.includes(questionId))
            return true;
        else return false
    };

    //handle the advanced disbursements number input change
    _handleAdNumberOfWeeksChange = (evt) => {
        this.props.changeAdvancedDisbursementsFormData({key:evt.target.name,value: evt.target.value});
    };

    _handleAdvancedDisbursementsNumberOfWeeksCheckBoxes = (id, checked, caseTypeId) => {
        this.props.changeAdExpenseTypes(id, checked, caseTypeId)
    };

    //action that handles the multi select list of sub cases
    _handleAdSelectedSubCaseTypes = (key, value) => {
        let selectedSubCaseTypes = [...this.props.solicitorGroup.advancedDisbursementsFormData.selectedSubCaseTypes];
        let checkedSubCaseTypesIds = [...this.props.solicitorGroup.advancedDisbursementsFormData.checkedSubCaseTypesIds];
        let subCaseTypes = [...this.props.caseTypes.subCases];

        const propsSubCases={
            selectedSubCaseTypeIndex:null,
            selectedSubCaseTypes: selectedSubCaseTypes,
            checkedSubCaseTypesIds: checkedSubCaseTypesIds,
            subCaseTypes:subCaseTypes,
            changeAdvancedDisbursementsFormData:this.props.changeAdvancedDisbursementsFormData,
            value:value

        }

        handleADSubCaseTypes(propsSubCases);
    };

    //function than handles the checked state of sub cases
    _handleAdCheckedSubCaseTypes = (subCaseTypeId, group) => {
        let checkedSubCaseTypesIds = this.props.solicitorGroup.advancedDisbursementsFormData.checkedSubCaseTypesIds;
        if (checkedSubCaseTypesIds.includes(subCaseTypeId)) {
            return true;
        }
        else {return false}
    };

    //for advanced disbursements
    _getSubCasesBasedOnSelectedCasesAd = () => {
        let checkedCaseTypesIds = [...this.props.solicitorGroup.advancedDisbursementsFormData.checkedCaseTypesIds];
        let subCaseTypes = [...this.props.caseTypes.subCases];
        let featuredSubCases = [];
        _.forEach(checkedCaseTypesIds, (caseTypeId) => {
            featuredSubCases = [...featuredSubCases, ..._.filter(subCaseTypes, item => {return item.caseTypeId === caseTypeId} )]
        });
        return featuredSubCases;
    };

    //function that returns true if the advanced disbursements case types can be updated
    _shouldUpdateAdSelectedCases = (newCaseTypeId) => {
        let checkedCaseTypesIds = [...this.props.solicitorGroup.advancedDisbursementsFormData.checkedCaseTypesIds];
        let selectedSubCaseTypes = [...this.props.solicitorGroup.advancedDisbursementsFormData.selectedSubCaseTypes];
        if(checkedCaseTypesIds.includes(newCaseTypeId)){
            let subCasesOfNewCaseType = _.find(selectedSubCaseTypes, item => {return item.caseTypeId === newCaseTypeId} );
            if(subCasesOfNewCaseType){
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };

    //calculate the disbursementsCaseTypeAndExpenseDtos
    _getAdCaseTypeAndExpenseDtos = () => {
        let dto = [];
        _.forEach(this.props.solicitorGroup.advancedDisbursementsFormData.selectedCaseTypes, caseType => {
            let dtoItem = {id: '', expenseTypeDtos: [], subCaseTypes: []};
            let cs = _.find(this.props.caseTypes.cases, i => {return i.id === caseType.id});
            dtoItem.id = caseType.id;
            _.forEach(this.props.solicitorGroup.advancedDisbursementsFormData.selectedSubCaseTypes, subCaseType => {
                let subCase = _.find(cs.subCaseTypes, item => {return item.id === subCaseType.id})
                if(subCase){
                    dtoItem.subCaseTypes.push({id: subCase.id})
                }
            });
            _.forEach(this.props.solicitorGroup.advancedDisbursementsFormData.checkedExpenseTypesPerCaseType, (value, key)=> {
                if(caseType.id.toString() === key){
                    _.forEach(value, (expenseValue, expenseKey) => {
                        if(expenseValue){
                            dtoItem.expenseTypeDtos.push({id: parseInt(expenseKey)})
                        }
                    })
                }
            });
            dto.push(dtoItem);
        });
        return dto;
    };

    _getTobaSelectOptions = () => {
        let options = this.props.tobas.map(toba => {
            return {key: toba.id, value: toba.name}
        });
        return options
    };

    _handleAmountChange = (name, value) => {
        if(_.isNaN(value)){
            return false;
        }
        this.props.changeAdvancedDisbursementsFormData({key:name, value:value});
    };

    _changeReferToByCaseType = (caseTypeId, key, value) => {
        this.props.changeReferToByCaseType(caseTypeId, key, value)
    };

    _changeReferToBySubCaseType = (subCaseTypeId, key, value) => {
        this.props.changeReferToBySubCaseType(subCaseTypeId, key, value)
    };

    //change the active panel
    _changePanel = (panel) => {
        this.props.changeInputGroup('activePanel', panel)
    };

    _getTobaselectOptions = () => {
        let options = this.props.tobas.map(toba => {
            return {key: toba.id, value: toba.name}
        });
        return options
    };

    addUnderwriter = (underwriter) => {
        this.props.addSolicitorGroupUnderwriter(underwriter)
    }

    editUnderwriter = (underwriter) => {
        this.props.editSolicitorGroupUnderwriter(underwriter);
    }

    removeUnderwriter = (indexOfUnderwriter, updateRelatedPolicies) => {
        this.props.removeSolicitorGroupUnderwriter({indexOfItemToRemove: indexOfUnderwriter, updateRelatedPolicies})
    }

    onMultiInputChanged = (key, value, action) => {
        if (action.action === 'input-change')
        {
            if(key === LEGAL_ADVICE_TEXT) {
                if (value.length < 3 && this.props.lawsysFirms.selectedLawsysFirmsDropdown.length === 0)
                {
                    this.props.changeLawsysFirmState('lawsysFirmsFiltered', []);
                    this.props.changeLawsysFirmState('selectedLawsysFirmsDropdown', []);
                }
                this.props.changeLawsysFirmState('suggestionFieldValue', value);
            }
        }
    };


    onMultiSelect = (key, values) => {
        if (key === LEGAL_ADVICE_TEXT) {
            const firms = values.map(x => ({id: x.value, name: x.label}));
            this.props.changeLawsysFirmState('lawsysFirmsFiltered', firms);
            this.props.changeLawsysFirmState('selectedLawsysFirmsDropdown', firms);
            this.props.changeLawsysFirmState('suggestionFieldValue', '');
            this.props.changeInputGroup('selectedSolicitors', firms);
        }
    };

    render() {
        this.getCaseTypesForRequest();
        return (
            <SolicitorGroup
                _handleAmountChange={this._handleAmountChange}
                _changeSelectedToba={this.props.changeSelectedToba}
                fetchingTobas={this.props.fetchingTobas}
                tobaSelectOptions={this._getTobaSelectOptions()}
                _changeAdvancedDisbursementsFormData={this.props.changeAdvancedDisbursementsFormData}
                _getSubCasesBasedOnSelectedCasesAd={this._getSubCasesBasedOnSelectedCasesAd}
                _handleAdCheckedSubCaseTypes={this._handleAdCheckedSubCaseTypes}
                _handleAdSelectedSubCaseTypes={this._handleAdSelectedSubCaseTypes}
                _handleAdvancedDisbursementsNumberOfWeeksCheckBoxes={this._handleAdvancedDisbursementsNumberOfWeeksCheckBoxes}
                expenseTypes={this.props.expenseTypes}
                _handleAdNumberOfWeeksChange={this._handleAdNumberOfWeeksChange}
                _handleAdvancedDisbursementsNumberOfWeeksCheckBox={this._handleAdvancedDisbursementsNumberOfWeeksCheckBox}
                _handleAdvancedDisbursementsMultipleExpenseTypes={this._handleAdvancedDisbursementsMultipleExpenseTypes}
                _handleAdvancedDisbursementsCheckedExpenseTypes={this._handleAdvancedDisbursementsCheckedExpenseTypes}
                _handleAdvancedDisbursementsCheckedCaseTypes={this._handleAdvancedDisbursementsCheckedCaseTypes}
                _handleAdvancedDisbursementsMultipleCaseTypes={this._handleAdvancedDisbursementsMultipleCaseTypes}
                _handleAdvancedDisbursementsCheckBoxes={this._handleAdvancedDisbursementsCheckBoxes}
                _changePanel={this._changePanel}
                _changeReferToBySubCaseType={this._changeReferToBySubCaseType}
                _changeReferToByCaseType={this._changeReferToByCaseType}
                filteredSubCases={this.getSubCasesBasedOnSelectedCases()} //sub cases are computed based on the selected case types
                caseTypes={this.props.caseTypes.cases} // case types
                caseTypesFetchingIndicator={this.props.caseTypes.fetching} //case types fetching  indicator
                subCaseTypes={this.props.caseTypes.subCases}
                handleSelectMultipleCaseTypes={this.handleSelectMultipleCaseTypes}
                handleCaseTypesCheckedState={this.handleCaseTypesCheckedState}
                handleSelectMultipleSubCaseTypes={this.handleSelectMultipleSubCaseTypes}
                handleSubCaseTypesCheckedState={this.handleSubCaseTypesCheckedState}
                router={this.props.router}
                push={this.props.push}
                goBack={this.props.goBack}
                solicitorGroupsList={this.props.solicitorGroupsList}
                requestDeleteSolicitorGroup={this.props.requestDeleteSolicitorGroup}
                HandleSubmit={this.HandleSubmit}
                SolicitorGroup={this.props.solicitorGroup}
                HandleCheckedState={this.handleCheckedState}
                handleSelectMultipleChange={this.handleSelectMultipleChange}
                ChangeField={this.props.changeField}
                PostNewGroup={this.postNewGoup}
                HandleSelectGroupChange={this.handleInputChange}
                HandleInputChange={this.props.changeInputGroup}
                lawsysFirms={this.props.lawsysFirms}
                addUnderwriter={this.addUnderwriter}
                editUnderwriter={this.editUnderwriter}
                removeUnderwriter={this.removeUnderwriter}
                wordingCategoriesAsListOptions={this.props.wordingCategoriesAsListOptions}
                handleWordingCategoryChange={this.handleWordingCategoryChange}
                onMultiSelect={this.onMultiSelect}
                onMultiInputChanged={this.onMultiInputChanged}
            />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const wordingCategoriesAsListOptions = [
        {key: '', value: ''},
        ...Object.values(state.wordingCategories.wordingCategories.byId)
            .map(e => ({key: e.id, value: e.name}))
    ]
    return {
        solicitorGroup: state.solicitorGroup,
        lawsysFirms: state.lawsysFirms,
        router: state.router,
        solicitorGroupsList: state.solicitorGroupsList,
        caseTypes: state.caseTypes,
        expenseTypes: state.expenseTypes.expenseTypes,
        tobas: state.tobas.validTobas,
        postingNewToba: state.toba.posting,
        fetchingTobas: state.tobas.fetching,
        wordingCategoriesAsListOptions
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUnderwriters: () => {
            dispatch(requestGetUnderwriters())
        },
        getWorkSources: () => {
            dispatch(requestGetWorkSources())
        },
        changeInputGroup: (field, data) => {
            dispatch(changeSolicitorGroupField(field, data))
        },
        postNewSolicitorGroup: (sendBody) => {
            dispatch(requestPostSolicitorGroup(sendBody))
        },
        getSolicitorGroups: () => {
            dispatch(requestGetSolicitorGroups())
        },
        patchSolicitorGroup: (groupId, newGroup) => {
            dispatch(requestPatchSolicitorGroup(groupId, newGroup))
        },
        changeField: (key, value) => {
            dispatch(changeField(key, value))
        },
        requestDeleteSolicitorGroup: (groupdId) => {
            dispatch(requestDeleteSolicitorGroup(groupdId))
        },
        requestPatchSelectedSolicitorGroup: (groupId, group) => {
            dispatch(requestPatchSelectedSolicitorGroup(groupId, group))
        },
        goBack: ()=> {
            dispatch(goBack())
        },
        requestGetSpecificSolicitorGroup: (id) => {
            dispatch(requestGetSpecificSolicitorGroup(id))
        },
        push: (url) => {
            dispatch(push(url))
        },
        requestGetSpecificSolicitorGroupEdit: (id)=> {
            dispatch(requestGetSpecificSolicitorGroupEdit(id))
        },
        getCaseTypes: () => {
            dispatch(getCaseTypes())
        },
        changeAdvancedDisbursementsFormData: (payload) => {
            dispatch(changeAdvancedDisbursementsFormData(payload))
        },
        getExpenseTypes: () => {
            dispatch(getExpenseTypes())
        },
        changeAdExpenseTypes: (id, checked, caseTypeId) => {
            dispatch(changeAdExpenseTypes(id, checked, caseTypeId))
        },
        getTobas: (parameters) => {
            dispatch(getTobas(parameters))
        },
        changeSelectedToba: (value) => {
            dispatch(changeSelectedToba(value))
        },
        changeReferToByCaseType: (caseTypeId, key, value) => {
            dispatch(changeReferToByCaseType(caseTypeId, key, value))
        },
        changeReferToBySubCaseType: (subCaseTypeId, key, value) => {
            dispatch(changeReferToBySubCaseType(subCaseTypeId, key, value))
        },
        getValidTobas: (parameters) => {
            dispatch(getValidTobas(parameters))
        },
        addSolicitorGroupUnderwriter: (payload) => {
            dispatch(addSolicitorGroupUnderwriter(payload))
        },
        editSolicitorGroupUnderwriter: (payload) => { dispatch(editSolicitorGroupUnderwriter(payload)) },
        removeSolicitorGroupUnderwriter: (payload) => { dispatch(removeSolicitorGroupUnderwriter(payload)) },
        fetchWordingCategories: (payload) => {dispatch(fetchWordingCategories(payload))},
        changeLawsysFirmState: (key, value) => { dispatch(changeLawsysFirmState(key, value)) },
        requestLawsysFirmsFiltered: (payload) => { dispatch(requestLawsysFirmsFiltered(payload))},
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SolicitorGroupHOC);
